import { Mapper } from "../../../../core/base";
import { TagWebEntity } from "./tag.web-entity";
import { Tag } from "../../../../core/domain/models";

export class TagWebRepositoryMapper extends Mapper<TagWebEntity, Tag> {
  mapFrom(param: TagWebEntity): Tag {
    return {
      id: param.id,
      name: param.name,
      description: param.description,
      associatedLocations: param.associatedLocations
    };
  }

  mapTo(param: Tag): TagWebEntity {
    return {
      id: param.id,
      name: param.name,
      description: param.description,
      associatedLocations: param.associatedLocations
    };
  }
}
